<template>
  <div>
    <!-- PERSONAL INFORMATION -->
    <div>
      <p class="font-weight-medium text-left">Personal Information</p>
      <v-form>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="First Name"
                placeholder="eg. John"
                outlined
                dense
                
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Middle Name"
                placeholder="eg. Davis"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Last Name"
                placeholder="eg. Doe"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Father's Name"
                placeholder="eg. Davis"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Mother's Name"
                placeholder="eg. Jane"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-select
                :items="items"
                label="Gender"
                outlined
                dense
              ></v-select>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
    <!-- CONTACT INFORMATION -->
    <div>
      <p class="font-weight-medium text-left">Contact Information</p>
      <v-form>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Phone number"
                placeholder="XXXXXXXXXX"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Alternate Number"
                placeholder="XXXXXXXXXX"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Email"
                placeholder="eg. abc@gmail.com"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>

    <!-- ACADEMIC INFORMATION -->

    <div>
      <p class="font-weight-medium text-left">Academic Information</p>
      <v-form>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Standard of Admission"
                placeholder="1st Standard"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Batch"
                placeholder="eg. 2020-2021"
                outlined
                disabled
                hint="Ref. Standard of Admission field"
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>

    <!-- ACADEMIC HISTORY-->
    <div>
      <p class="font-weight-medium text-left">Academic History</p>
      <v-form>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Previous School. (optional)"
                placeholder="eg. DPS"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Previous Std. (optional)"
                placeholder="eg. 4th STD"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Previous Std Percentage. (optional)"
                placeholder="eg. 92.40"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>

    <!-- Other Info-->
    <div>
      <p class="font-weight-medium text-left">Other Information</p>
      <v-form>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Is specially abled?"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "EnquiryStepperContent",

  data: () => ({
    items: ["Male", "Female", "Other"]
  })
};
</script>

<style>
</style>